import { memo } from 'react'

import { Text } from '@cash-me/react-components'

import { homeRenovationFaqAccordion } from 'data/home-renovation-loan'
import { Help } from 'modules/help-v2'

type Props = {
  onClick: () => void
}

export const HomeRenovationHelp = memo(({ onClick }: Props) => (
  <Help
    accordion={homeRenovationFaqAccordion}
    $bg="medium"
    $previousBG="neutral-background-default"
    buttonAriaLabel="Simular empréstimo para reforma de casa agora"
    layoutVariant="long-form"
    showButtonArrow={false}
    onClick={onClick}
  >
    <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-contrast-default)">
      <Text as="span" size="heading2" weight="medium" color="var(--colors-cyan-background-pressed)">
        Tire as suas dúvidas{' '}
      </Text>
      sobre o Empréstimo para Reforma de Casa
    </Text>
  </Help>
))

HomeRenovationHelp.displayName = 'HomeRenovationHelp'
